import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { Grid } from '@material-ui/core';
import { Form, Row, Select, Transfer, Tooltip, Col } from 'antd';
import Input from '../../ui/Input';
import { getOTACodes } from '../../../services/common';
import { SearchOutlined } from '@ant-design/icons';
import { PROXIMITY_OPTIONS } from '@constants/index';
import './index.scss';
import { isTagsDisplayed } from '@helpers/FeatureFlags';

export const measurementUnits = ['Feet', 'Meters', 'Yard', 'Miles'];

const validTypes = [
  'Incoming fax complimentary',
  'Outgoing fax complimentary',
  'Fee charged for first page',
  'Fee charged for first page of outgoing fax',
  'Fee per additional page of incoming fax',
  'Fee per additional page of outgoing fax',
];

const { Option } = Select;
let errHandle = false;

const AddPage = forwardRef((props: any, ref: any) => {
  const [form] = Form.useForm();

  const [transferData, setTransferData] = useState<Array<any>>([]);
  const [transferTargetKeys, setTransferTargetKeys] = useState<Array<any>>([]);
  const [data, setData] = useState<Array<any>>([]);
  const [typeList, setTypeList] = useState<Array<any>>([]);
  const [typeValue, setTypeValue] = useState<string>('');
  const [measurementUnits, setMeasurementUnits] = useState<Array<string>>([]);

  const handleCategoryChange = async (e: any, i: any) => {
    form.setFields([
      {
        name: 'type',
        value: '',
      },
    ]);
    let res;
    if (e === 'Hotel Amenities') {
      res = await getOTACodes('HAC', '');
    } else if (e === 'Business Services') {
      res = await getOTACodes('BUS', '');
    } else if (e === 'Meal Plans') {
      res = await getOTACodes('MPT', '');
    } else if (e === 'Meeting Services') {
      res = await getOTACodes('MRC', '');
    }
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => (item.key = item.codeName));
      setTypeList(res.otacodes);
    } else {
      setTransferData([]);
    }
  };
  useEffect(() => {
    // getTransferData()
    getAvailabilityList();
    return () => {
      errHandle = false;
    };
  }, []);
  // get transfer
  // const getTransferData = async () => {
  //     // setAddLoading(true)
  //     let res = await getOTACodes('CHG', 'ChargeFrequency')
  //     // setAddLoading(false)
  //     if (res && res.otacodes && res.otacodes.length != 0) {
  //         res.otacodes.map((item: any) => item.key = item.codeName)
  //         setTransferData(res.otacodes)
  //         setData(res.otacodes)
  //     } else {
  //         setTransferData([])
  //     }
  // };

  const getAvailabilityList = async () => {
    // setAddLoading(true)
    let res = await getOTACodes('TAG', '');
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => (item.key = item.codeName));
      setTransferData(res.otacodes);
      setData(res.otacodes);
    } else {
      setTransferData([]);
    }
  };
  const onSearchChange = (e: any) => {
    let res = data.filter(
      (item) =>
        item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
    );
    setTransferData(res);
  };
  const handleChange = (targetKeys: any) => {
    setTransferTargetKeys(targetKeys);
    props.getTransferData(targetKeys);
  };

  // const addSave = () => {
  //     form.validateFields().then(async (value) => {
  //         const get_session = new LocalPersistence('session')
  //         const session: any = await get_session.getSessionPersistence()
  //         value.tags = transferTargetKeys.length != 0 ? transferTargetKeys.join(' | ') : ''
  //         const params = {
  //             "supplier": session.supplier,
  //             "propertyId": session.propertyId,
  //             "property": {
  //                 "amenityservice": [
  //                     {
  //                         "name": value.name,
  //                         "category": value.category,
  //                         "type": value.type,
  //                         "included": value.includedinRoomRate,
  //                         "proximity": value.proximity,
  //                         "typedetail": value.typedetail,
  //                         "avail": value.avail,
  //                         "id": value.iD,
  //                         "quantity": value.quantity,
  //                         "distance": value.distance,
  //                         "tags": value.tags
  //                     }
  //                 ]
  //             }
  //         }
  //         const res = await addAmenityservice(params);
  //         if (res.result.success) {
  //             props.cancelAndSave();
  //         }

  //     })
  // }

  const getOTA_UOMCodes = async () => {
    let codeName = [];
    const res = await getOTACodes('UOM', 'Distance');
    if (res && res.otacodes && res.otacodes.length !== 0) {
      codeName = res.otacodes.map((item: any) => {
        return item.codeName;
      });
      setMeasurementUnits(codeName);
    } else {
      setMeasurementUnits([]);
    }
  };

  useImperativeHandle(ref, () => ({
    detailForm: form,
    restoreErr: () => {
      errHandle = false;
    },
  }));

  useEffect(() => {
    if (errHandle) {
      props.validateFieldsError();
    } else {
      errHandle = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getOTA_UOMCodes();
  }, []);

  const onChangeType = (type: string) => {
    setTypeValue(type);
    const s = validTypes.find((e: string) => e === type);
    if (!s) {
      form.setFieldsValue({ lanyoncomments: '' });
    }
  };

  const validTypeSelected = () => {
    const s = validTypes.find((e: string) => e === typeValue);
    return s;
  };

  return (
    <>
      <Grid
        container
        spacing={0}
        className="containerSpacing py-0"
      >
        <Grid
          item
          xs={12}
          className="p-0"
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* <div style={{ fontWeight: 'bold', fontSize: 14, color: '#333' }}>Amenities & Services</div> */}
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          className="pb-0 px-0 my-0"
        >
          <Form
            layout="vertical"
            form={form}
            name="basic"
            initialValues={{ remember: true }}
            onValuesChange={(changedFields, allFields) => {
              console.log(changedFields, allFields);
              props.validateFieldsError();
            }}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      max: 64,
                      message:
                        'You have reached the max character length of 64',
                    },
                  ]}
                >
                  <Input maxLength={64} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Category"
                  name="category"
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}
                >
                  <Select allowClear defaultValue=""
                    onChange={(e) => handleCategoryChange(e, i)}
                    showSearch
                  >
                    <Option value="Hotel Amenities">Hotel Amenities </Option>
                    <Option value="Business Services">Business Services</Option>
                    <Option value="Meal Plans">Meal Plans</Option>
                    <Option value="Meeting Services">Meeting Services</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="type"
                  label="Type"
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}
                >
                  <Select allowClear defaultValue=""
                    onChange={onChangeType}
                    showSearch>
                    {typeList.length > 0 &&
                      typeList.map((item: any, index: any) => {
                        return (
                          <Option
                            key={index}
                            value={item.codeName}
                          >
                            {item.codeName}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Type Detail"
                  name="typedetail"
                  rules={[
                    {
                      max: 50,
                      message:
                        'You have reached the max character length of 50',
                    },
                  ]}
                >
                  <Input maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Availability"
                  name="avail"
                  rules={[{}]}
                >
                  <Select allowClear defaultValue=""
                    showSearch>
                    <Option value="Complimentary to All">
                      Complimentary to All
                    </Option>
                    <Option value="Complimentary to Consortia Only">
                      Complimentary to Consortia Only
                    </Option>
                    <Option value="Available">Available</Option>
                    <Option value="Available at a Charge">
                      Available at a Charge
                    </Option>
                    <Option value="Subject to Availability">
                      Subject to Availability
                    </Option>
                    <Option value="Not Available">Not Available</Option>
                    <Option value="Cost not known or varies">
                      Cost not known or varies
                    </Option>
                    {/* {availabilityList.length > 0 && availabilityList.map((val: any, ind: any) => {
                                        return (
                                            <Option key={ind} value={val.codeName}>{val.codeName}</Option>
                                        )
                                    })} */}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  label="Service ID"
                  name="id"
                  rules={[
                    {
                      max: 32,
                      message:
                        'You have reached the max character length of 32',
                    },
                  ]}
                >
                  <Input maxLength={32} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Quantity"
                  name="quantity"
                  rules={[
                    {
                      required: false,
                      pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                      message: 'This field should be a number',
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="included"
                  label="Included in Room Rate"
                  rules={[]}
                >
                  <Select allowClear defaultValue=""
                    showSearch>
                    <Option value="Yes">Yes</Option>
                    <Option value="No">No</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  label="Proximity"
                  name="proximity"
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}
                >
                  <Select allowClear defaultValue=""
                    showSearch>
                    {Object.values(PROXIMITY_OPTIONS).map(
                      (item: string, index: number) => (
                        <Option
                          key={index}
                          value={item}
                        >
                          {item}
                        </Option>
                      )
                    )}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Distance"
                  name="distance"
                  rules={[
                    {
                      pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                      message: 'This field should be a number',
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Measurement Units"
                  name="uom"
                  rules={[
                    {
                      max: 25,
                      message:
                        'You have reached the max character length of 25',
                    },
                  ]}
                >
                  <Select allowClear onChange={(e: string) => console.log(e)}
                    showSearch
                    value={props.state}
                  >
                    {measurementUnits.map((rt: string, index: number) => (
                      <Option
                        value={rt}
                        key={index}
                      >
                        {rt}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
              {validTypeSelected() && (
                <Col span={6}>
                  <Form.Item
                    label="Lanyon Comments"
                    name="lanyoncomments"
                    rules={[
                      {
                        max: 25,
                        message:
                          'You have reached the max character length of 25',
                      },
                    ]}
                  >
                    <Input maxLength={25} />
                  </Form.Item>
                </Col>
              )}
              <Col span={6}></Col>
            </Row>
            {isTagsDisplayed && (
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item
                    name="tags"
                    label="Selected Tags"
                  >
                    <Input
                      onChange={onSearchChange}
                      style={{ width: '300px' }}
                      suffix={
                        <Tooltip title="search">
                          <SearchOutlined
                            style={{ color: 'rgba(0,0,0,.45)' }}
                          />
                        </Tooltip>
                      }
                    />
                    <Transfer
                      dataSource={transferData}
                      targetKeys={transferTargetKeys}
                      onChange={handleChange}
                      render={(item) => item.codeName}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            {/* <Row>
                        <Col span={18}>
                            <div style={{ height: '50px', display: 'flex', justifyContent: 'flex-end', padding: '8px', marginTop: '10px' }}>
                                <p>
                                    <Button type='primary' style={{ background: '#dc3545', borderColor: '#dc3545' }} onClick={handlCancelClick}>Cancel</Button>
                                    <Button onClick={addSave} type='primary' style={{ marginLeft: 10 }}>Save</Button>
                                </p>
                            </div>
                        </Col>
                    </Row> */}
          </Form>
        </Grid>
      </Grid>
    </>
  );
});
export default AddPage;

function i(e: string, i: any): void {
  throw new Error('Function not implemented.');
}
